import React from 'react';
import { Box, CircularProgress } from '@mui/material';

let initialContent = null;

export function captureSeoPrerender() {
  const article = document.querySelector('#root > .seo-prerender');
  initialContent = article ? { url: window.location.pathname + window.location.search, html: article.outerHTML } : null;
}

export function clearSeoPrerender() {
  initialContent = null;
  document.documentElement.removeAttribute('data-trackme-app');
}

export function getSeoPrerender() {
  return initialContent?.url === window.location.pathname + window.location.search ? initialContent.html : null;
}

export function finishAppStartup() {
  if (initialContent?.url !== window.location.pathname + window.location.search) {
    initialContent = null;
  }
  document.documentElement.removeAttribute('data-trackme-app');
}

export default function AppLoadingFallback() {
  return <Box role="status" aria-label="Загрузка страницы" sx={{ minHeight: '100svh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'var(--background-color-fon)' }}>
    <CircularProgress size={32} sx={{ color: 'var(--green-color)' }} />
  </Box>;
}
